import api from './api';

export const getEmployeeCustomFields = (employeeId) => api.get(`/employees/${employeeId}/custom-fields`);
export const getEmployeeCustomField = (employeeId, fieldName) => api.get(`/employees/${employeeId}/custom-fields/${fieldName}`);
export const updateEmployeeCustomFields = (employeeId, fieldsObject) => api.put(`/employees/${employeeId}/custom-fields`, fieldsObject);
export const updateEmployeeCustomField = (employeeId, fieldName, value) => api.put(`/employees/${employeeId}/custom-fields/${fieldName}`, { value });

export const getCustomFieldsMetadata = () => api.get('/employees/custom-fields/metadata');
export const updateCustomFieldsMetadata = (metadataObject) => api.post('/employees/custom-fields/metadata', metadataObject);
export const getEmployeeCustomFieldsMetadata = (employeeId) => api.get(`/employees/${employeeId}/custom-fields/metadata`);

export default {
  getEmployeeCustomFields,
  getEmployeeCustomField,
  updateEmployeeCustomFields,
  updateEmployeeCustomField,
  getCustomFieldsMetadata,
  updateCustomFieldsMetadata,
  getEmployeeCustomFieldsMetadata,
};
